import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { TooltipStyleStates } from './types';

const styles = {
  root: ({ props: { disabled, pointer } }) =>
    css({
      ...(disabled && {
        '& + .MuiTooltip-popper': {
          display: 'none',
        },
      }),
      ...(pointer && { cursor: 'pointer' }),
    }),
} satisfies Styles<TooltipStyleStates>;

export const useStyles = withStyles(styles);
